<template>
  <div class="resource-section">
    <div class="section-title dynamic-content" v-html="resourceTitleText"></div>
    <div class="section-sub-title pending-section-home-title">
      <div class="dynamic-content" v-html="resourceSecondTitle"></div>
      <div class="see-more" @click="setResourceCardStatus" v-show="isHome" v-html="seeMoreOrLessText"></div>
    </div>
    <div class="resources-container">
      <div class="resource-item" v-for="(item, index) in resources" :key="index">
          <img class="header-image" :src="item.imgSrc" :width="251" :height="137"/>
          <div style="height: 229px">
            <div class="resource-content">
              <div class="header">{{ item.header }}</div>
              <div class="content">{{ item.content }}</div>
            </div>
            <div class="buttons">
              <maf-button :name="item.buttonText" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="learnMore(item.link)"></maf-button>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import mymafAppImgSrc from '../../assets/my-maf-app.png';
import resourceFinder from '../../assets/resource-finder.png';
import financialCoaching from '../../assets/financial-coaching.png';
import financialEmergency from '../../assets/financical-emergency.png';
import mijaAppImg from '../../assets/mija-app-resource.png';

export default {
  name: 'Resource',
  props: {},
  data () {
    return {
      isShowAll: false,
      resourceList: [
        {
          imgSrc: mymafAppImgSrc,
          header: 'MyMAF App',
          content: 'Track your progress, view your loans, payment history, and details about your program.',
          buttonText: 'Learn More',
          link: 'https://www.missionassetfund.org/mymaf/',
        },
        {
          imgSrc: resourceFinder,
          header: 'Resources Finder',
          content: 'Find programs and services to help you weather the pandemic',
          buttonText: 'Find resources',
          link: 'https://www.missionassetfund.org/resources-finder/',
        },
        {
          imgSrc: financialCoaching,
          header: 'Financial Coaching',
          content: 'Make an appointment with one of our financial coaches  to speak about credit, savings, and more!',
          buttonText: 'Book appointment',
          link: ' https://forms.missionassetfund.org/appointment-cita?source=portal',
        },
        {
          imgSrc: financialEmergency,
          header: 'Financial Emergency Action Plan for Immigrants',
          content: 'Keep your money and belongings safe in the case of an immigration emergency.',
          buttonText: 'Download guide',
          link: 'https://www.missionassetfund.org/feapi/',
        },
        {
          imgSrc: resourceFinder,
          header: 'More Programs',
          content: 'We’re building programs and services in real time that meet the complex needs of low-income communities.',
          buttonText: 'Learn more',
          link: 'https://www.missionassetfund.org/programs/',
        },
        {
          imgSrc: mijaAppImg,
          header: 'MIJA',
          content: 'An app designed to guide users through the U.S. immigration process with personalized plans, resources, and educational tools',
          buttonText: 'Visit MIJA',
          link: 'https://mafmija.app/',
        }
      ]
    }
  },
  methods: {
    setResourceCardStatus() {
      this.isShowAll = !this.isShowAll;
    },
    learnMore(url) {
      window.open(url);
    }
  },
  computed: {
    ...mapState({
      currentTab: state => state.currentTab
    }),
    seeMoreOrLessText() {
      if (this.isShowAll) {
        return 'See less >';
      }

      return 'See more >';
    },
    isHome() {
      return this.currentTab.label === 'Home';
    },
    resourceTitleText() {
      if (this.isHome) {
        return 'More Resources for You';
      }
      return 'Resources';
    },
    resourceSecondTitle() {
      if (this.isHome) {
        return 'Take a look at our other services:';
      }

      return 'Here are more resources for you';
    },
    resources() {
      if (this.isShowAll === true) {
        return this.resourceList;
      }

      if (this.isHome) {
        return this.resourceList.slice(0, 3);
      }

      return this.resourceList;
    }
  }
}
</script>
<style lang="scss" scoped>
@import './../../sass/main.scss';
$div-space-size: 10px;

.resource-section {
  @include inner-component-pc;
  font-size: $font-size-base;

  @media screen and (max-width: $max-width-phone) {
    @include inner-component-mobile;
  }

  .pending-section-home-title {
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: $max-width-phone) {
      display: block;
    }
  }

  .see-more {
    font-family: sans-serif;
    font-size: 18px;
    color: #878787;
    cursor: pointer;

    @media screen and (max-width: $max-width-phone) {
      margin-top: 10px;
    }
  }

  .section-title {
    @include section-title;

    @media screen and (max-width: $max-width-phone) {
      font-size: $font-size-larger;
    }
  }

  .section-sub-title {
    @include section-sub-title;
    font-size: $font-size-larger;

    @media screen and (max-width: $max-width-phone) {
      font-size: $font-size-large;
    }
  }

  .resources-container {
    padding: 0px 20px 0px 45px;
    @include center-style;
    flex-wrap: wrap;
    justify-content: flex-start;
    font-family: sans-serif;

    @media screen and (max-width: $max-width-phone) {
      padding: unset;
      justify-content: flex-start;

    }

    @media screen and (max-width: 500px) {
      justify-content: center;
    }
  }

  .resource-item {
    margin: 15px;
    @include center-style;
    flex-direction: column;
    width: 239px;
    height: 354px;
    background: $border-color-header;
    text-align: center;
    border-radius: 5px;

    .buttons {
      height: 40px;
    }

    .maf-btn {
      width: 80% !important;
    }

    .learn-more {
      margin-top: $div-space-size;
      font-size: $font-size-large;
      color: $font-color-sub-title;
      cursor: pointer;
    }
  }

  .header-image {
    margin-top: -3px;
  }

  .resource-content {
    margin-bottom: $div-space-size;
    padding: $div-space-size;
    height: 160px;

    .header {
      font-family: ncaDashboardFont;
    }

    .content {
      padding-top: $div-space-size;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resources/Resource.vue